export const validationMessages = {
  "isValid": false,
  "messages": "",
  "steps": [
    {
      "id": "BackgroundPattern",
      "errors": [
        "Background Pattern is required."
      ]
    },
    {
      "id": "BorderType",
      "errors": [
        "Border Type is required."
      ]
    },
    {
      "id": "BorderColor",
      "errors": [
        "Border Colour is required."
      ]
    },
    {
      "id": "Backing",
      "errors": [
        "Backing is required."
      ]
    },
    {
      "id": "Combination",
      "errors": [
        "Combination is required."
      ],
      "fields": null
    },
    {
      "id": "DesignType",
      "errors": [
        "Upload Image is required."
      ]
    },
    {
      "id": "Emblem3d",
      "errors": [
        "3D Emblem Indications are required."
      ]
    },
    {
      "id": "EmblemLeather",
      "errors": [
        "Leather Emblem Indications are required."
      ]
    },
    {
      "id": "EmblemPrintStitch",
      "errors": [
        "Print Stitch Emblem Instructions are required."
      ],
      "fields": null
    },
    {
      "id": "FabricColor",
      "errors": [
        "Fabric/Media Colour is required."
      ]
    },
    {
      "id": "HolographicUpload",
      "errors": [
        "Holographic Upload Image is required."
      ]
    },
    {
      "id": "HolographicColors",
      "errors": [
        "Minimum of 1 Colour is required."
      ]
    },
    {
      "id": "Layout",
      "errors": [
        "Layout is required."
      ]
    },
    {
      "id": "ProductType",
      "errors": [
        "Product Type is missing or invalid."
      ]
    },
    {
      "id": "ProductSubtype",
      "errors": [
        "Product Subtype is missing or invalid."
      ]
    },
    {
      "id": "Scrolling",
      "errors": [],
      "fields": [
        {
          "id": "scrollingText",
          "errors": [
            "Scrolling Text is required."
          ]
        },
        {
          "id": "scrollingFont",
          "errors": [
            "Scrolling Font is required."
          ]
        }
      ]
    },
    {
      "id": "SewingChannel",
      "errors": [
        "Sewing Channel is required."
      ]
    },
    {
      "id": "SewingGuideColor",
      "errors": [
        "Sewing Guide Colour is required."
      ]
    },
    {
      "id": "Shape",
      "errors": [
        "Shape is required."
      ]
    },
    {
      "id": "SizeStandard",
      "errors": [
        "Dimensions are required."
      ]
    },
    {
      "id": "ThreadColors",
      "errors": [
        "Minimum of 1 Colour is required."
      ]
    }
  ]
}